import React, { useState, useEffect, useRef } from "react"
import SectionHeader from "../../molecules/SectionHeader"
import Clutch from "../../atoms/Clutch"
import "./styles.scss"

import { gsap } from "gsap"

import emoji1 from "../../../assets/images/homepage/memoji-item.png"
import emoji2 from "../../../assets/images/homepage/memoji-item-1.png"
import emoji3 from "../../../assets/images/homepage/memoji-item-4.png"
import emoji4 from "../../../assets/images/homepage/memoji-item-3.png"
import emoji5 from "../../../assets/images/homepage/memoji-item-2.png"

const Hero = ({
  title,
  subtitle,
  paragraph,
  showClutchRev,
  clutchRating,
  numberOfReviews,
}) => {
  const clutchReview = showClutchRev ? (
    <div className="hero__clutchReview">
      <p className="clutch__content">{paragraph}</p>
      <Clutch numberOfReviews={numberOfReviews} rating={clutchRating} />
    </div>
  ) : (
    ""
  )

  return (
    <>
      <section className={`section section--homehero`}>
        <div className="wrapper">
          <div className="hero__content">
            <SectionHeader
              animate
              type="h1"
              subtitle={subtitle}
              className="hero__title hero__titleCentered"
              attributes={{
                "data-sal": "slide-up",
                "data-sal-duration": "1000",
                "data-sal-easing": "ease",
              }}
            >
              {title}
            </SectionHeader>
            {clutchReview}
          </div>
        </div>
      </section>
      <div className="hero__separator"></div>
    </>
  )
}
export default Hero
